import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE } from "@/data/siteContent";

const getLanguageFromPath = (path) => (path.startsWith("/en") ? "en" : "fr");

const normalizePath = (path, language) => {
  if (path === "/") {
    return language === "en" ? "/en" : "/fr";
  }
  return path;
};

const upsertLink = (selector, attributes) => {
  let link = document.querySelector(selector);
  if (!link) {
    link = document.createElement("link");
    Object.entries(attributes).forEach(([key, value]) => {
      link.setAttribute(key, value);
    });
    document.head.appendChild(link);
    return;
  }
  Object.entries(attributes).forEach(([key, value]) => {
    link.setAttribute(key, value);
  });
};

export const usePageMeta = (title, description) => {
  const location = useLocation();

  useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }

    const language = getLanguageFromPath(location.pathname);
    const canonicalPath = normalizePath(location.pathname, language);
    const baseUrl = SITE?.baseUrl || "";

    if (baseUrl) {
      const canonicalUrl = `${baseUrl}${canonicalPath}`;
      upsertLink('link[rel="canonical"]', {
        rel: "canonical",
        href: canonicalUrl,
      });
    }
  }, [title, description, location.pathname]);
};